import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class AnexoService {

    postAnexo(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/anexo/inclui/', item, { observe: 'response' })
    };

    getAnexoBaixar(itemId: any): Observable<Blob> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/anexo/baixar/' + itemId,  { responseType: 'blob' })
    }

    postVisualizaAnexoPorFiltro(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/anexo/visualizaporfiltro/', item, { observe: 'response' })
    }

    delete(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
          environment.webApiSaguiControlUrl + '/api/anexo/exclui/' + itemId, { observe: 'response' })
      }

    download(anexo: any) {

        this.getAnexoBaixar(anexo.anexoId).subscribe(data => {

            let link = document.createElement("a");

            link.setAttribute("target", "_blank");

            if (Blob !== undefined) {

                var blob = new Blob([data], { type: anexo.ContentType });

                link.setAttribute("href", URL.createObjectURL(blob));

            }

            link.setAttribute("download", anexo.nomeArquivo);

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);


        });

    }

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
